import { useEffect, useRef, useState } from 'react'
import PageHeader from '../../components/PageHeader'
import Select from "react-select"
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"
import { LMSBASEURL } from '../../config/apiUrls';
import { Table, Card, Tooltip, OverlayTrigger } from "react-bootstrap";
import { PaginationControls } from '../../components/PaginationControls';
import { Button } from "react-bootstrap"
import NoDataFound from '../../components/NoDataFound';
import { useNavigate } from 'react-router-dom';

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #ced4da",
    boxShadow: 'none',
    '&:hover': {
      border: "1px solid #ced4da",
    },

    minHeight: "38px",
    fontSize: "14px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#6c757d",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#495057",
  }),
}

const getInitials = (title) => {
  const words = title.trim().split(" ");
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

function InstituteAnnouncement() {
    const navigate = useNavigate()
    const role = sessionStorage.getItem("role");
    const dashboardPath = role === 'Institute' ? '/institute-dashboard' : '/dashboard';
    const [selectedNotiType,setSelectedNotiType] = useState(null)
    const instituteId = sessionStorage.getItem("instituteId");
    const token = process.env.REACT_APP_API_TOKEN;
    const [loadingNoti, setLoadingNoti] = useState(true);
    const [errorNoti, setErrorNoti] = useState("");
    const [filderDate, setfilderDate] = useState(new Date());
    const [notifications, setNotifications] = useState([]);
    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 10,
        last_page: 1,
    });

    const getNotification = async (page = 1, date=null) => {
        const formateDate = new Date(date)
        const formatted = formateDate?.toISOString().split("T")[0]; 
        setLoadingNoti(true)
        try {
            const headers = new Headers({
                "Authorization": token,
                "Accept": "application/json",
                "Content-Type": "application/json",
            });

            const body = JSON.stringify({
                page,
                per_page: pagination.per_page,
                institute_id: instituteId,
                date: date == null ?"":formatted,
                type:selectedNotiType == null ? '':selectedNotiType?.value,
            });

            const response = await fetch(`${LMSBASEURL}/api/getnotification`, {
                method: "POST",
                headers,
                body,
                redirect: "follow",
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Unable to load Notification. (${response.status}) - ${errorText}`);
            }

            const { data } = await response.json();

            setNotifications(data?.items || []);
            setPagination(data?.meta || {});
        } catch (error) {
            setErrorNoti(error.message);
        }finally{
            setLoadingNoti(false)
        }
    };

    useEffect(() => {
        sessionStorage.removeItem('editNoti')
        getNotification( pagination.current_page,null);
    }, [selectedNotiType]);

    const handlePageChange = (page) => {
        getNotification(page,null);
    };
    
    const handleEndDateChange = (date) => {
        if (date) {
            setfilderDate(date)
            getNotification(pagination.current_page,date);
        }
    }

    const handleEditNotification=(n)=>{
        sessionStorage.setItem("editNoti",JSON.stringify(n))
        navigate('/create-announcement?edit=true')
    }

    console.log("e.target.value",notifications)

    return (
        <>
            <div className="col-12">
                <PageHeader title="Announcement" 
                    breadcrumbs={[
                        { label: "Dashboard", path: dashboardPath },
                        { label: "Announcement", active: true }
                    ]}
                />
            </div>
            <div className='mb-4 bg-white rounded py-3 mx-1 px-3 border'>
                <div className="row ">
                    <div className={"col-lg-3 col-sm-12" }>
                        <div className="mb-2">
                            <label className="form-label text-uppercase fw-bold  small mb-1">Filter By Type:</label>
                            <Select
                                options={[
                                    { label: "Browser Notification", value: "fcmnotification" },
                                    { label: "Email Notification", value: "email" }
                                ]}
                                value={selectedNotiType}
                                onChange={setSelectedNotiType}
                                placeholder="Select Type"
                                styles={customSelectStyles}
                                isClearable
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                />

                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label className="form-label text-uppercase fw-bold  small mb-1">Date:</label>
                        <DatePicker
                            selected={filderDate}
                            onChange={handleEndDateChange}
                            dateFormat="dd/MM/yyyy"
                            className="form-control form-control-sm datepickerheight"
                            placeholderText="Select end date"
                        />
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className='d-flex justify-content-end mt-4'>
                            <Button variant="primary" className='' onClick={()=> navigate('/create-announcement')}>Create Announcement</Button>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                {loadingNoti ? 
                <div className="container-fluid py-4">
                    <div className="row">
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3 ">Loading Notification...</p>
                    </div>
                    </div>
                </div>
                :
                <div className="d-none d-md-block p-1">
                    {notifications.length > 0 ? (
                    <Table hover bordered responsive className="rounded-4">
                        <thead>
                        <tr>
                            <th>Title</th>
                            <th>Type</th>
                            <th>Programs</th>
                            <th>Scheduled On</th>
                            <th>Status</th>
                            <th className='tableNoWrap'>Sent Count</th>
                            <th>Created By</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {notifications.map((n) => (
                            <tr key={n.id}>
                            <td>{n.title}</td>
                            <td className='text-capitalize'>{n.type=='fcmnotification' ? 'Browser Notification':"Email Notification"}</td>
                            <td>
                                {n?.program_titles?.length == 0 ? '-':<>
                                
                                    {n.program_titles.map((p, idx) => (
                                    <OverlayTrigger
                                        key={idx}
                                        placement="top"
                                        overlay={<Tooltip>{p}</Tooltip>}
                                    >
                                        <span className="badge bg-primary me-1">
                                        {getInitials(p)}
                                        </span>
                                    </OverlayTrigger>
                                    ))}
                                </>}
                            </td>
                            <td>{n.scheduled_on}</td>
                            <td>{n.status}</td>
                            <td>{n.sent_count}</td>
                            <td>{n.created_by_name}</td>
                            <td><button onClick={()=>handleEditNotification(n)} className='btn btn-sm btn-danger'>Edit</button></td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    ) : (
                    <NoDataFound className=' bg-light rounded-3' message='No Announcements Found'/>
                    )}
                </div>
                }

                <div className="d-md-none">
                    {notifications.length > 0 ? (
                    notifications.map((n) => (
                        <Card key={n.id} className="mb-3">
                        <Card.Body>
                            <Card.Title>{n.title}</Card.Title>
                            <Card.Subtitle className="mb-2 ">
                            {n.scheduled_on}
                            </Card.Subtitle>
                            <div className="mb-2">
                            {n.program_titles.map((p, idx) => (
                                <OverlayTrigger
                                key={idx}
                                placement="top"
                                overlay={<Tooltip>{p}</Tooltip>}
                                >
                                <span className="badge bg-primary me-1">
                                    {getInitials(p)}
                                </span>
                                </OverlayTrigger>
                            ))}
                            </div>
                            <div>
                            <strong>Status:</strong> {n.status}
                            </div>
                            <div>
                            <strong>Sent:</strong> {n.sent_count}
                            </div>
                            <div>
                            <strong>By:</strong> {n.created_by_name}
                            </div>
                        </Card.Body>
                        </Card>
                    ))
                    ) : (
                        <NoDataFound message='No Announcements Found'/>
                    )}
                </div>

                {pagination && pagination?.current_page !== 1 && (
                    <div className="d-flex justify-content-end mt-3">
                    <PaginationControls
                        pagination={pagination}
                        onPageChange={handlePageChange}
                    />
                    </div>
                )}
            </div>

            <style>

                {`
                .react-datepicker-wrapper,
                    .react-datepicker__input-container {
                    display: block;
                    width: 100%;    
                }
                .datepickerheight{
                    height:37px;
                    color:#6d6e72;
                    font-size:14px;
                }
                `}
            </style>
        </>
    )
}

export default InstituteAnnouncement